var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactsEmptyTwoPersons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 23.625C10.125 26.9071 11.4288 30.0547 13.7496 32.3754C16.0703 34.6962 19.2179 36 22.5 36C25.7821 36 28.9297 34.6962 31.2504 32.3754C33.5712 30.0547 34.875 26.9071 34.875 23.625C34.875 20.3429 33.5712 17.1953 31.2504 14.8746C28.9297 12.5538 25.7821 11.25 22.5 11.25C19.2179 11.25 16.0703 12.5538 13.7496 14.8746C11.4288 17.1953 10.125 20.3429 10.125 23.625Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 60.75C2.25 55.3794 4.38348 50.2287 8.18109 46.4311C11.9787 42.6335 17.1294 40.5 22.5 40.5C27.8706 40.5 33.0213 42.6335 36.8189 46.4311C40.6165 50.2287 42.75 55.3794 42.75 60.75",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7531 13.248C44.6217 12.0339 46.7835 11.3468 49.0101 11.2594C51.2368 11.172 53.4458 11.6874 55.4038 12.7513C57.3618 13.8152 58.9963 15.3881 60.1345 17.3039C61.2727 19.2197 61.8725 21.4072 61.8706 23.6356C61.8687 25.864 61.2651 28.0505 60.1235 29.9643C58.9819 31.8781 57.3448 33.4482 55.3849 34.5087C53.4251 35.5692 51.2152 36.0808 48.9887 35.9895C46.7621 35.8982 44.6016 35.2074 42.7351 33.99",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41.001C47.9657 40.3291 51.0445 40.3331 54.0084 41.0125C56.9723 41.6919 59.7454 43.0295 62.1223 44.9261C64.4991 46.8227 66.4189 49.2297 67.7393 51.9689C69.0596 54.7081 69.7469 57.7092 69.75 60.75",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsEmptyTwoPersons);
export default __webpack_public_path__ + "static/media/ContactsEmptyTwoPersons.31b20180cd3e989b97e4f8a6b2487734.svg";
export { ForwardRef as ReactComponent };